import React, { useState } from "react";
import { MediaField } from "../practiceGuide/components/MediaField";

export function TipsAndDrillsMediaUpload({ uploadFn, onMetadata, media }) {
  return (
    <>
      <MediaField
        label="Instructional Video"
        name="instructionalVideo"
        type="video"
        src={media?.instructionalVideo?.src}
        height={320}
        accept="video/*"
        uploadFn={uploadFn}
        onMetadata={onMetadata}
      />

      {!!media?.instructionalVideo?.src && (
        <MediaField
          label="Instructional Video Thumbnail"
          name="instructionalVideoThumbnail"
          type="image"
          src={media?.instructionalVideoThumbnail?.src}
          height={142}
          accept="image/*"
          uploadFn={uploadFn}
        />
      )}

      <MediaField
        label="Rep Loop Video"
        name="repVideo"
        type="video"
        src={media?.repVideo?.src}
        height={320}
        accept="video/*"
        uploadFn={uploadFn}
      />
    </>
  );
}
